import { Flex } from '@chakra-ui/react';
import splashImg from '../../../assets/newLogo.svg';
import { AnimatedImage, SplashContainer } from '../styles/SplashStyles';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
const Splash = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate('/get-started');
        }, 2000);

        // Cleanup timer on component unmount
        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <SplashContainer>
            <Flex w="full" h="full" justify="center" alignItems="center" flexDir="column">
                <AnimatedImage src={splashImg} alt="Splash Img" w="80%" />
            </Flex>
        </SplashContainer>
    );
};

export default Splash;
